/**
 * Created by fabianbr on 6/20/2017.
 */

import {IziToastSettings} from "izitoast";

export const PENDING_TOASTERS_KEY = 'pending_toasters';

export const DISPLAYED_TOASTERS_KEY = 'displayed_toasters';

export enum TOASTER_NOTIFICATION_TYPES {
	SHOW = 1,
	OK_PRESSED = 3,
	GAME_OPEN = 3
};

export const TOASTER_UI_CONFIG = {
	globalClass: 'CGPToasterLayout cy-toaster-layout',
	titleFont: 'Main',
	titleSize: 'mediumSecondary',
	titleColor: 'main',
	messageFont: 'Main',
	messageSize: 'mediumSecondary',
	messageColor: 'base01',
	backgroundColor: 'darkMain',
	progressColor: 'main',
	progressBackgroundColor: 'base02',
	buttonColor: 'main',
	buttonFont: 'Type04',
	buttonTextColor: 'darkMain',
	buttonCornerRadius: 'ctacornerradius'
};

export const LIB_CSS_IDS = {
	closeBtn: 'iziToast-close',
	container: 'iziToast-wrapper',
	cover: '.iziToast-cover',
    toastBody: '.iziToast-body',
    toastTexts: '.iziToast-texts'
};

export enum TOAST_TYPES {
	TIMED = 'timed_toaster',
	ACKNOWLEDGE = 'acknowledge_toaster',
	ACTION = 'action_toaster'
};

export enum TRANSITIONS {
	BOUNCE_IN_LEFT = 'bounceInLeft',
	BOUNCE_IN_RIGHT = 'bounceInRight',
	BOUNCE_IN_UP = 'bounceInUp',
	BOUNCE_IN_DOWN = 'bounceInDown',
	FADE_IN = 'fadeIn',
	FADE_IN_DOWN = 'fadeInDown',
	FADE_IN_UP = 'fadeInUp',
	FADE_IN_LEFT = 'fadeInLeft',
	FADE_IN_RIGHT = 'fadeInRight',
	FLIP_IN_X = 'flipInX',
	FADE_OUT = 'fadeOut',
	FADE_OUT_UP = 'fadeOutUp',
	FADE_OUT_DOWN = 'fadeOutDown',
	FADE_OUT_LEFT = 'fadeOutLeft',
	FADE_OUT_RIGHT = 'fadeOutRight',
	FLIP_OUT_X = 'flipOutX'
};

export enum POSITION {
	BOTTOM_RIGHT = 'bottomRight',
	BOTTOM_LEFT = 'bottomLeft',
	TOP_RIGHT = 'topRight',
	TOP_LEFT = 'topLeft',
	TOP_CENTER = 'topCenter',
	BOTTOM_CENTER = 'bottomCenter',
	CENTER = 'center'
};

export let DEFAULT_CONFIG: Partial<IziToastSettings> = {
	// class: '',
	// title: '',
	// titleSize: 14,
	// titleColor: 'black',
	// message: '',
	// messageSize: 13,
	// messageColor: 'black',
	// backgroundColor: '#E8E8E8',
	// color: '', // blue, red, green, yellow
	// icon: '',
	// iconText: '',
	// iconColor: '',
	// image: '',
	imageWidth: 45,
	// zindex: 99999,
	layout: 2, //layout 2 means 3 separate lines, one for title one for message text and one for buttons
	// balloon: false,
	close: true,
	rtl: false,
	position: POSITION.TOP_RIGHT,
	// target: '',
	targetFirst: false,
	timeout: 5000,
	// maxWidth: '412px',
	drag: false,
	pauseOnHover: true,
	resetOnHover: false,
	progressBar: true,
	// progressBarColor: '#CCCCCC',
	animateInside: false,
	// buttons: {},
	transitionIn: TRANSITIONS.FADE_IN_LEFT,
	transitionOut: TRANSITIONS.FADE_OUT_RIGHT,
	transitionInMobile: TRANSITIONS.FADE_IN_LEFT,
	transitionOutMobile: TRANSITIONS.FADE_OUT_RIGHT
	// onOpened: function () {},
	// onClosed: function () {}
};
